import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AppPhase, DealerConsoleAction } from '../../../models/communication/app-enums.model';
import { AppState } from '../../../models/communication/app-state.model';

/**
 * A collection of buttons that enable supervisor to send a `DealerConsoleAction`.
 *
 * Supervisor rules when each action is available are defined in the following
 * [table](https://troniusgaming.atlassian.net/wiki/spaces/Product/pages/471138344/iDAT?force_transition=38d35250-49a1-4b62-a559-fae9a6b2b56e).
 */
@Component({
    selector: 'app-supervisor-actions',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './supervisor-actions.component.html',
    styleUrl: './supervisor-actions.component.scss'
})
export class SupervisorActionsComponent {
    @Input()
    state!: AppState;

    @Output()
    readonly actionClicked = new EventEmitter<{
        button: HTMLButtonElement;
        action: DealerConsoleAction;
    }>();

    protected readonly AppPhase = AppPhase;
    protected readonly DealerConsoleAction = DealerConsoleAction;
}
